import React from 'react';

const TermsOfService = () => {
  const containerStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '2rem',
    alignItems: 'flex-start',
  };

  const columnStyle = {
    flex: '1 1 320px',
    minWidth: '320px',
    padding: '0 1rem',
  };

  const headingStyle = {
    marginBottom: '1rem',
    fontSize: '1.2rem',
    fontWeight: '700',
  };

  const sectionStyle = {
    marginBottom: '1.5rem',
  };

  return (
    <div style={containerStyle}>
      <div style={columnStyle}>
        <div style={headingStyle}>English</div>

        <h2 style={sectionStyle}>1. Provider Information</h2>
        <p>These Terms of Service (“Terms”) govern the use of services provided by:</p>
        <p>
          <strong>RPSwiss.ch</strong><br />
          Association: Association of Russian Speaking Professionals in Switzerland<br />
          Email: info@rpswiss.ch<br />
          Website: https://www.rpswiss.ch<br />
          Address: Chemin de Burquenet, 1095, Lutry, Switzerland
        </p>
        <p>By accessing the website or purchasing services, you agree to these Terms.</p>

        <h2 style={sectionStyle}>2. Scope of Services</h2>
        <p>The Provider offers memberships, products and services in line with the aims of the association.</p>

        <h2 style={sectionStyle}>3. Nature of Services</h2>
        <p>Memberships, products and services in line with the aims of the association.</p>

        <h2 style={sectionStyle}>4. Eligibility</h2>
        <p>You must be at least 18 years old (or have legal guardian consent), have the legal capacity to enter into binding agreements, and ensure that accessing services is lawful in your jurisdiction.</p>
        <p>The Provider reserves the right to decline or terminate services if deemed inappropriate or outside scope of competence.</p>

        <h2 style={sectionStyle}>5. Cross-Border Services</h2>
        <p>Clients accessing services from outside the Provider’s licensing jurisdiction acknowledge that laws and regulations governing psychological services vary by country.</p>
        <p>It is the client’s responsibility to ensure compliance with local laws. The Provider makes no representation regarding the regulatory status of services in the client’s jurisdiction.</p>

        <h2 style={sectionStyle}>6. Booking and Contract Formation</h2>
        <p>A contract is formed when a booking is confirmed in writing and/or payment is received.</p>
        <p>Memberships, products and services are subject to availability.</p>

        <h2 style={sectionStyle}>7. Fees and Payment</h2>
        <p>Fees are stated on the website or agreed in writing. Payment must be made in advance unless otherwise agreed. Accepted payment methods are specified at checkout.</p>
        <p>Failure to pay may result in cancellation of services.</p>

        <h2 style={sectionStyle}>8. Cancellation and Rescheduling</h2>
        <p>Unless otherwise agreed, cancellations made less than 24–48 hours before a scheduled session may be charged in full.</p>
        <p>The Provider may reschedule sessions due to unforeseen circumstances. Specific program or package refund policies will be stated at the time of purchase.</p>

        <h2 style={sectionStyle}>9. Confidentiality</h2>
        <p>The Provider maintains confidentiality in accordance with applicable professional and legal standards.</p>
        <p>Exceptions may apply where disclosure is required by law, there is risk of harm to the client or others, or supervision/professional consultation is necessary (with anonymization where possible).</p>
        <p>Online communication involves inherent risks. Absolute data security cannot be guaranteed.</p>

        <h2 style={sectionStyle}>10. Data Protection and Privacy</h2>
        <p>Personal data is processed in accordance with applicable data protection laws. Details are set out in the Privacy Policy.</p>

        <h2 style={sectionStyle}>11. Intellectual Property</h2>
        <p>All materials provided (documents, recordings, exercises, frameworks, digital content) remain the intellectual property of the Provider.</p>
        <p>You may not reproduce, distribute, or commercially exploit materials without written permission.</p>

        <h2 style={sectionStyle}>12. No Guarantee of Results</h2>
        <p>The Provider does not guarantee specific outcomes for its products and services.</p>
        <p>You remain responsible for your decisions and actions.</p>

        <h2 style={sectionStyle}>13. Limitation of Liability</h2>
        <p>To the fullest extent permitted by law, the Provider shall not be liable for indirect, incidental, or consequential damages.</p>
        <p>Total liability is limited to the amount paid for the specific service giving rise to the claim.</p>
        <p>Nothing in these Terms excludes liability for gross negligence, intentional misconduct, or mandatory statutory obligations.</p>

        <h2 style={sectionStyle}>14. Technology Disclaimer</h2>
        <p>The Provider is not responsible for internet connectivity issues, third-party platform failures, or data breaches beyond reasonable control.</p>
        <p>Any online services require that clients are responsible for ensuring adequate technical conditions for online sessions.</p>

        <h2 style={sectionStyle}>15. Termination</h2>
        <p>The Provider may terminate services if the client violates these Terms, payment obligations are not fulfilled, or the services fall outside professional scope or appropriateness.</p>
        <p>Clients may terminate at any time subject to cancellation terms.</p>

        <h2 style={sectionStyle}>16. Amendments</h2>
        <p>The Provider may update these Terms at any time. The version in force at the time of booking applies.</p>

        <h2 style={sectionStyle}>17. Governing Law and Jurisdiction</h2>
        <p>These Terms are governed by the laws of Switzerland, unless mandatory consumer protection laws of the client’s country apply.</p>
        <p>Any disputes shall be subject to the jurisdiction of the courts of Switzerland, unless otherwise required by law.</p>
      </div>
      {/* --- IGNORE ---
       <div style={columnStyle}>
        <div style={headingStyle}>English</div>
      <div style={columnStyle}>
        <div style={headingStyle}>Русский</div>

        <h2 style={sectionStyle}>1. Информация о поставщике</h2>
        <p>Настоящие Условия обслуживания ("Условия") регулируют использование услуг, предоставляемых:</p>
        <p>
          <strong>RPSwiss.ch</strong><br />
          Ассоциация: Ассоциация русскоязычных профессионалов Швейцарии<br />
          Email: info@rpswiss.ch<br />
          Сайт: https://www.rpswiss.ch<br />
          Адрес: Chemin de Burquenet, 1095, Lutry, Switzerland
        </p>
        <p>Получая доступ к сайту или приобретая услуги, вы соглашаетесь с настоящими Условиями.</p>

        <h2 style={sectionStyle}>2. Объем услуг</h2>
        <p>Поставщик предлагает членские взносы, товары и услуги в соответствии с целями ассоциации.</p>

        <h2 style={sectionStyle}>3. Характер услуг</h2>
        <p>Членские взносы, товары и услуги в соответствии с целями ассоциации.</p>

        <h2 style={sectionStyle}>4. Право на получение услуг</h2>
        <p>Вы должны быть не моложе 18 лет (или иметь письменное согласие законного представителя), обладать правоспособностью для заключения обязательных соглашений и убедиться, что получение услуг законно в вашей юрисдикции.</p>
        <p>Поставщик оставляет за собой право отказать в предоставлении услуг или прекратить их, если это сочтено неуместным или выходит за рамки компетенции.</p>

        <h2 style={sectionStyle}>5. Трансграничные услуги</h2>
        <p>Клиенты, получающие услуги из юрисдикций, отличных от места лицензирования Поставщика, признают, что законы и регламенты, регулирующие психологические услуги, различаются по странам.</p>
        <p>Клиент обязан обеспечить соблюдение местного законодательства. Поставщик не делает заявлений о правовом статусе услуг в юрисдикции клиента.</p>

        <h2 style={sectionStyle}>6. Бронирование и заключение договора</h2>
        <p>Договор считается заключённым в момент подтверждения бронирования в письменной форме и/или получения оплаты.</p>
        <p>Членские взносы, товары и услуги зависят от наличия.</p>

        <h2 style={sectionStyle}>7. Оплата и расчет</h2>
        <p>Тарифы указаны на сайте или согласуются в письменной форме. Оплата должна быть произведена заранее, если не оговорено иное. Приемлемые способы оплаты указываются при оформлении заказа.</p>
        <p>Отсутствие оплаты может привести к отмене услуг.</p>

        <h2 style={sectionStyle}>8. Отмена и перенос</h2>
        <p>Если не оговорено иначе, отмены, сделанные менее чем за 24–48 часов до запланированной сессии, могут быть оплачены в полном объёме.</p>
        <p>Поставщик может перенести сессии по независящим от него обстоятельствам. Политики возврата по программам или пакетам указываются при покупке.</p>

        <h2 style={sectionStyle}>9. Конфиденциальность</h2>
        <p>Поставщик обеспечивает конфиденциальность в соответствии с применимыми профессиональными и правовыми стандартами.</p>
        <p>Исключения возможны, если раскрытие требуется законом, существует риск вреда клиенту или другим лицам, или требуется супервизия/профессиональная консультация (по возможности с анонимизацией).</p>
        <p>Онлайн‑коммуникация связана с определёнными рисками. Абсолютная безопасность данных не может быть гарантирована.</p>

        <h2 style={sectionStyle}>10. Защита данных и конфиденциальность</h2>
        <p>Персональные данные обрабатываются в соответствии с применимым законодательством о защите данных. Подробности приведены в Политике конфиденциальности.</p>

        <h2 style={sectionStyle}>11. Интеллектуальная собственность</h2>
        <p>Все предоставляемые материалы (документы, записи, упражнения, методические материалы, цифровой контент) остаются интеллектуальной собственностью Поставщика.</p>
        <p>Воспроизводить, распространять или коммерчески использовать материалы без письменного разрешения запрещено.</p>

        <h2 style={sectionStyle}>12. Отсутствие гарантии результатов</h2>
        <p>Поставщик не гарантирует конкретные результаты своих товаров и услуг.</p>
        <p>Вы остаётесь ответственным за свои решения и действия.</p>

        <h2 style={sectionStyle}>13. Ограничение ответственности</h2>
        <p>В максимально допустимой законом степени Поставщик не несёт ответственности за косвенные, случайные или последующие убытки.</p>
        <p>Общая ответственность ограничивается суммой, уплаченной за конкретную услугу, давшую повод к претензии.</p>
        <p>Ничто в настоящих Условиях не исключает ответственности за грубую небрежность, умышленные правонарушения или обязательства, предусмотренные законом.</p>

        <h2 style={sectionStyle}>14. Техническое предупреждение</h2>
        <p>Поставщик не отвечает за проблемы с подключением к интернету, сбои сторонних платформ или утечки данных, находящиеся вне разумного контроля.</p>
        <p>Клиенты обязаны обеспечить адекватные технические условия для онлайн‑сессий.</p>

        <h2 style={sectionStyle}>15. Прекращение</h2>
        <p>Поставщик может прекратить предоставление услуг, если клиент нарушает настоящие Условия, не выполняет платёжные обязательства или услуги выходят за рамки профессиональной компетенции.</p>
        <p>Клиенты могут прекратить получение услуг в любое время в соответствии с условиями отмены.</p>

        <h2 style={sectionStyle}>16. Изменения</h2>
        <p>Поставщик может вносить изменения в настоящие Условия в любое время. Применяется версия, действующая на момент бронирования.</p>

        <h2 style={sectionStyle}>17. Применимое право и юрисдикция</h2>
        <p>Настоящие Условия регулируются законодательством Швейцарии, если иное не требуется применимыми обязательными нормами о защите прав потребителей.</p>
        <p>Любые споры подлежат рассмотрению в судах Швейцарии, если иное не установлено законом.</p>
      </div>
      */}
    </div>
  );
};

export default TermsOfService;

